import { getPercentageDiff } from '@workalizer/shared/utils';
var prevCountFromDiffString = function (current, diffString) {
    var pct = Number(diffString.replace('%', '').replace('+', ''));
    if (pct === 0) {
        return current;
    }
    return Math.round(current / (1 + pct / 100));
};
var buildPreviousPeriod = function (current, diffStrings) { return ({
    views: getPercentageDiff(prevCountFromDiffString(current.views, diffStrings.views), current.views),
    edits: getPercentageDiff(prevCountFromDiffString(current.edits, diffStrings.edits), current.edits),
    comments: getPercentageDiff(prevCountFromDiffString(current.comments, diffStrings.comments), current.comments),
    downloads: getPercentageDiff(prevCountFromDiffString(current.downloads, diffStrings.downloads), current.downloads)
}); };
var buildDoc = function (id, title, currentPeriod, diffStrings) { return ({
    id: id,
    title: title,
    currentPeriod: currentPeriod,
    previousPeriod: buildPreviousPeriod(currentPeriod, diffStrings),
    total: currentPeriod.views +
        currentPeriod.edits +
        currentPeriod.comments +
        currentPeriod.downloads
}); };
var mostPopularDocumentsRows = [
    {
        id: 1,
        title: 'Q4 Marketing Strategy',
        currentPeriod: { views: 156, edits: 23, comments: 8, downloads: 12 },
        diffStrings: {
            views: '8%',
            edits: '28%',
            comments: '-20%',
            downloads: '33%'
        }
    },
    {
        id: 2,
        title: 'Annual Budget Planning',
        currentPeriod: { views: 89, edits: 15, comments: 12, downloads: 7 },
        diffStrings: {
            views: '-14%',
            edits: '114%',
            comments: '50%',
            downloads: '-13%'
        }
    },
    {
        id: 3,
        title: 'Product Roadmap 2025',
        currentPeriod: { views: 234, edits: 31, comments: 19, downloads: 18 },
        diffStrings: {
            views: '24%',
            edits: '63%',
            comments: '58%',
            downloads: '50%'
        }
    },
    {
        id: 4,
        title: 'Team Performance Review',
        currentPeriod: { views: 67, edits: 8, comments: 5, downloads: 3 },
        diffStrings: {
            views: '-11%',
            edits: '33%',
            comments: '25%',
            downloads: '50%'
        }
    },
    {
        id: 5,
        title: 'Technical Documentation',
        currentPeriod: { views: 198, edits: 42, comments: 15, downloads: 25 },
        diffStrings: {
            views: '51%',
            edits: '75%',
            comments: '67%',
            downloads: '92%'
        }
    },
    {
        id: 6,
        title: 'Client Meeting Notes',
        currentPeriod: { views: 45, edits: 6, comments: 3, downloads: 2 },
        diffStrings: {
            views: '-21%',
            edits: '-14%',
            comments: '50%',
            downloads: '100%'
        }
    },
    {
        id: 7,
        title: 'Quarterly OKRs Summary',
        currentPeriod: { views: 120, edits: 18, comments: 9, downloads: 10 },
        diffStrings: {
            views: '20%',
            edits: '50%',
            comments: '11%',
            downloads: '25%'
        }
    },
    {
        id: 8,
        title: 'Customer Feedback Digest',
        currentPeriod: { views: 142, edits: 14, comments: 17, downloads: 8 },
        diffStrings: {
            views: '6%',
            edits: '17%',
            comments: '42%',
            downloads: '-11%'
        }
    },
    {
        id: 9,
        title: 'Sprint Planning Board',
        currentPeriod: { views: 98, edits: 26, comments: 11, downloads: 5 },
        diffStrings: {
            views: '-6%',
            edits: '37%',
            comments: '0%',
            downloads: '67%'
        }
    },
    {
        id: 10,
        title: 'Security Review Checklist',
        currentPeriod: { views: 76, edits: 9, comments: 14, downloads: 12 },
        diffStrings: {
            views: '15%',
            edits: '13%',
            comments: '40%',
            downloads: '71%'
        }
    },
    {
        id: 11,
        title: 'Data Retention Policy',
        currentPeriod: { views: 168, edits: 12, comments: 7, downloads: 9 },
        diffStrings: {
            views: '20%',
            edits: '-14%',
            comments: '40%',
            downloads: '50%'
        }
    },
    {
        id: 12,
        title: 'Team Onboarding Guide',
        currentPeriod: { views: 131, edits: 16, comments: 6, downloads: 18 },
        diffStrings: {
            views: '23%',
            edits: '33%',
            comments: '-14%',
            downloads: '64%'
        }
    },
    {
        id: 13,
        title: 'Project Charter v2',
        currentPeriod: { views: 104, edits: 22, comments: 10, downloads: 7 },
        diffStrings: {
            views: '15%',
            edits: '57%',
            comments: '43%',
            downloads: '17%'
        }
    },
    {
        id: 14,
        title: 'Operational Metrics Report',
        currentPeriod: { views: 150, edits: 10, comments: 13, downloads: 6 },
        diffStrings: {
            views: '-3%',
            edits: '30%',
            comments: '85%',
            downloads: '0%'
        }
    },
    {
        id: 15,
        title: 'Roadmap Risk Register',
        currentPeriod: { views: 87, edits: 19, comments: 8, downloads: 11 },
        diffStrings: {
            views: '12%',
            edits: '46%',
            comments: '-20%',
            downloads: '55%'
        }
    }
];
export var mostPopularDocuments = function () {
    return mostPopularDocumentsRows.map(function (row) {
        return buildDoc(row.id, row.title, row.currentPeriod, row.diffStrings);
    });
};
